/**
 * Dust Motes
 *
 * 16 floating gold particles. Direction and timing determined by variant prop,
 * which applies a CSS class that activates page-specific nth-child rules.
 */

import React from 'react';

export type DustVariant = 'drift' | 'rise' | 'lateral' | 'converge' | 'stoneFall' | 'smoke' | 'multiDirectional';

interface DustMotesProps {
  variant: DustVariant;
}

const MOTE_COUNT = 16;

export const DustMotes: React.FC<DustMotesProps> = ({ variant }) => {
  return (
    <div className={`dust-motes dust-${variant}`}>
      {Array.from({ length: MOTE_COUNT }, (_, i) => (
        <div key={i} className="mote" />
      ))}
    </div>
  );
};
